import { AfterViewInit, Component, Input, ElementRef, ViewChild } from '@angular/core';
import { MapifyMap } from '../../models/MapifyMap';
import { Size } from '../../models/Size';

@Component({
  selector: 'mpf-map-container',
  templateUrl: './map-container.component.html',
  styleUrls: ['./map-container.component.scss']
})
export class MapContainerComponent implements AfterViewInit {
  private _mapSize: Size;

  @Input() map: MapifyMap;

  @Input()
  set mapSize(size: Size) {
    this._mapSize = size;
    this.setContainerSize();
  }

  get mapSize() {
    return this._mapSize;
  }

  @ViewChild('wrapper') wrapper: ElementRef;
  @ViewChild('container') container: ElementRef;

  width: string;
  height: string;

  constructor() {}

  ngAfterViewInit(): void {
    window.addEventListener('resize', this.setContainerSize.bind(this));
  }

  /**
   * Calculates the container size in pixels preserving the map aspect ratio.
   * It could be possible that the container in which that map is going to be rendered does not have the same
   * aspect ratio as the map size configured (50x70, 91x61, etc). This function will resize the container accordingly
   * to preserve the specified map size aspect ratio.
   */
  private setContainerSize() {
    const ratio = this.mapSize.width / this.mapSize.height;
    const containerRatio = this.wrapper.nativeElement.offsetWidth / this.wrapper.nativeElement.offsetHeight;

    if (ratio >= containerRatio) {
      this.setSizeBasedOnWidth();
    } else {
      this.setSizeBasedOnHeight();
    }
  }

  setSizeBasedOnWidth() {
    const width = this.wrapper.nativeElement.offsetWidth;
    const height = (width / this.mapSize.width) * this.mapSize.height;

    this.width = width + 'px';
    this.height = height + 'px';
  }

  setSizeBasedOnHeight() {
    const height = this.wrapper.nativeElement.offsetHeight;
    const width = (height / this.mapSize.height) * this.mapSize.width;

    this.width = width + 'px';
    this.height = height + 'px';
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/map-container/map-container.component.ts